export default "__VITE_ASSET__Ba16If7Y__"